export const defaultMapViewState = {
    latitude: 55.751244,
    longitude: 37.618423,
    zoom: 10,
    bearing: 0,
    pitch: 0
}

export const defaultLayerProperties = {
    id: "area-layer",
    type: "fill",
    paint: {
        "fill-color": ["coalesce", ["feature-state", "color"], ["get", "color"]],
        "fill-outline-color": ["coalesce", ["feature-state", "outlineColor"], ["get", "outlineColor"]],
        "fill-opacity": 0.85,
        "fill-antialias": true,
        "fill-color-transition": { duration: 300, delay: 0 },
    },
};

export const highlightLayerProperties = {
    id: "highlight-layer",
    type: "line",
    paint: {
        "line-color": "#ffffff",
        "line-width": 4,
        "line-blur": 2,
        "line-opacity": 0.9,
    }
}

export const labelsLayerProperties = {
    id: "labels-layer",
    type: "symbol",
    layout: {
        "text-field": ["get", "label"],
        "text-size": 12,
        "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
        "text-anchor": "center",
        "text-allow-overlap": true,
        "text-ignore-placement": true,
    },
    paint: {
        "text-color": "#000000",
        "text-halo-color": "#ffffff",
        "text-halo-width": 2,
        "text-halo-blur": 1,
    }
}